import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { NgModule, ModuleWithProviders } from '@angular/core';
// import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { CommonModule } from '@angular/common';
import { LoadingComponent } from './loading/loading.component';
import { ErrorDialogComponent } from './error-dialog/error-dialog.component';
import { ErrordialogService } from './error-dialog/errordialog.service';
import { TekstSelectionDirective } from './tekst-selection.directive';
import { LoadingData } from './cevi-http-interceptor';
import { AuthInterceptor } from 'src/app/cevi-shared/auth-interceptor';
import { ErrorInterceptor } from 'src/app/cevi-shared/error-interceptor';
import { LoadingInterceptor } from 'src/app/cevi-shared/loading/loading-interceptor';


@NgModule({
    imports: [
        CommonModule,
        HttpClientModule,
        LoadingComponent, ErrorDialogComponent, TekstSelectionDirective,
    ],
    exports: [ErrorDialogComponent, LoadingComponent, TekstSelectionDirective],
})
export class CeviSharedModule {
  static forRoot(): ModuleWithProviders<CeviSharedModule> {
    return {
      ngModule: CeviSharedModule,
      providers: [
        LoadingData,
        ErrordialogService,
        {
          provide: HTTP_INTERCEPTORS,
          useClass: AuthInterceptor,
          multi:true
        },
        {
          provide: HTTP_INTERCEPTORS,
          useClass: ErrorInterceptor,
          multi:true
        },
        {
          provide: HTTP_INTERCEPTORS,
          useClass: LoadingInterceptor,
          multi: true
        }
      ]
    };
  }
}
